import styled from 'styled-components';
const SvgIconMLStyled = styled.span`
  /* display: flex; */
  font-size: 0 !important;
  line-height: 1 !important;
  .icon {
    fill: currentColor;
  }
`;
export default SvgIconMLStyled;
